import styled, { css } from 'styled-components'
import { ReactComponent as Add } from '../../../../../assets/src/lib/icons/dataplace/add.svg'

export const AddIcon = styled(Add)(({ theme }) => {
  const {
    palette, corners,
  } = theme
  return css`
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
    padding: 0.15rem;
    cursor: pointer;
    border-radius: ${corners.default.borderRadius};
    > path {
      stroke: ${palette.blue};
    }

    :active {
      > path {
        stroke: ${palette.blue};
      }
    }

    :hover {
      background-color: ${palette.light.darker};
      > path {
        stroke: ${palette.blue};
      }
    }

    :focus {
      outline: none;
      background-color: ${palette.dark.lightest};
      > path {
        stroke: ${palette.light.white};
      }
    }
  `
})
